import { State } from "types/State";
import { BaseService, ResponseData } from "./baseService";

class StateService extends BaseService<State> {
  controllerName = "states";

  async getGeolocation(address: string): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();

    const { data } = await this.api.post(
      `/${this.controllerName}/geolocation`,
      { address }
    );
    return data;
  }
}

export const stateService = new StateService();
